import { render } from "./ArticleSearch.vue?vue&type=template&id=d8b3889a"
import script from "./ArticleSearch.vue?vue&type=script&lang=js"
export * from "./ArticleSearch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__